import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-aria-container{left:-999em;position:absolute}";
n(css,{});
export { css, css as default };
